<template>
  <div class="detail">
    <div class="header">
      <div class="title">详情</div>
      <div class="extra" @click="$emit('changeVisible')">
        <a-icon type="close" />
      </div>
    </div>
      <div style="padding: 1rem;height: 82vh;overflow-y: auto;">
        <a-tabs v-model="activeTab">
            <a-tab-pane key="1" tab="基本详情">
                <div class="pipe">
                    <template v-if="renderDetail.wellFrom && (renderDetail.wellTo || renderDetail.drainTo)">
                        <img class="bg" src="../../../assets/icons/pipe4.png" />
                    </template>
                    <template v-if="!renderDetail.wellFrom && (renderDetail.wellTo || renderDetail.drainTo)">
                        <img class="bg" src="../../../assets/icons/pipe2.png" />
                    </template>
                    <template v-if="renderDetail.wellFrom && !(renderDetail.wellTo || renderDetail.drainTo)">
                        <img class="bg" src="../../../assets/icons/pipe1.png" />
                    </template>
                    <template v-if="!renderDetail.wellFrom && !(renderDetail.wellTo || renderDetail.drainTo)">
                        <img class="bg" src="../../../assets/icons/pipe3.png" />
                    </template>

                    <template v-if="renderDetail.wellFrom">
                        <template v-if="renderDetail.wellFrom.depth">
                            <template v-if="renderDetail.wellFrom.depth > 4">
                                <img class="length1" src="../../../assets/icons/length/8.png" alt=""/>
                            </template>
                            <template v-else-if="renderDetail.wellFrom.depth > 3.5">
                                <img class="length1" src="../../../assets/icons/length/7.png" alt=""/>
                            </template>
                            <template v-else-if="renderDetail.wellFrom.depth > 3">
                                <img class="length1" src="../../../assets/icons/length/6.png" alt=""/>
                            </template>
                            <template v-else-if="renderDetail.wellFrom.depth > 2.5">
                                <img class="length1" src="../../../assets/icons/length/5.png" alt="" />
                            </template>
                            <template v-else-if="renderDetail.wellFrom.depth > 2">
                                <img class="length1" src="../../../assets/icons/length/4.png" alt="" />
                            </template>
                            <template v-else-if="renderDetail.wellFrom.depth > 1.5">
                                <img class="length1" src="../../../assets/icons/length/3.png" alt="" />
                            </template>
                            <template v-else-if="renderDetail.wellFrom.depth > 1">
                                <img class="length1" src="../../../assets/icons/length/2.png" alt="" />
                            </template>
                            <template v-else-if="renderDetail.wellFrom.depth > 0.5">
                                <img class="length1" src="../../../assets/icons/length/1.png" alt="" />
                            </template>
                            <template v-else>
                                <img class="length1" src="../../../assets/icons/length/1.png" alt=""/>
                            </template>
                        </template>
                        <template v-else>
                            <img class="length1" src="../../../assets/icons/length/1.png" alt=""  />
                        </template>

                        <div class="well-from-depth">
                            井深{{
                            renderDetail.wellFrom.depth ? renderDetail.wellFrom.depth : "-"
                            }}米
                        </div>
                        <div class="well-from-elevation">
                            地面高程：{{
                            parseFloat(renderDetail.wellFrom.elevation).toFixed(3)
                            }}m
                        </div>
                        <div class="well-from-elevation2">
                            井底高程：{{
                            parseFloat(
                                renderDetail.wellFrom.elevation -
                                (renderDetail.wellFrom.depth ? renderDetail.wellFrom.depth : 0)
                            ).toFixed(3)
                            }}m
                        </div>

                        <div class="well-from-id">
                            窨井编号：{{ renderDetail.wellFrom.code }}
                        </div>

                        <template v-if="renderDetail.wellFrom.pipeFrom">
                            <div class="from-elevation">
                                管底高程：{{ renderDetail.elevationFrom }}m
                            </div>

                            <div class="from-elevation2">
                                距离井底：{{
                                parseFloat(
                                    renderDetail.wellFrom.depth -
                                    renderDetail.wellFrom.pipeFrom.buringDepthTo
                                ).toFixed(3)
                                }}m
                            </div>

                            <div class="from-elevation3">
                                管顶高程：{{
                                parseFloat(
                                    renderDetail.elevationFrom +
                                    renderDetail.wellFrom.pipeFrom.diameter * 0.001
                                ).toFixed(3)
                                }}m
                            </div>
                        </template>
                    </template>

                    <template v-if="renderDetail.wellTo">
                        <template v-if="renderDetail.wellTo.depth">
                            <template v-if="renderDetail.wellTo.depth > 4">
                                <img
                                        class="length2"
                                        src="../../../assets/icons/length/8.png"
                                        alt=""
                                />
                            </template>
                            <template v-else-if="renderDetail.wellTo.depth > 3.5">
                                <img
                                        class="length2"
                                        src="../../../assets/icons/length/7.png"
                                        alt=""
                                />
                            </template>
                            <template v-else-if="renderDetail.wellTo.depth > 3">
                                <img
                                        class="length2"
                                        src="../../../assets/icons/length/6.png"
                                        alt=""
                                />
                            </template>
                            <template v-else-if="renderDetail.wellTo.depth > 2.5">
                                <img
                                        class="length2"
                                        src="../../../assets/icons/length/5.png"
                                        alt=""
                                />
                            </template>
                            <template v-else-if="renderDetail.wellTo.depth > 2">
                                <img
                                        class="length2"
                                        src="../../../assets/icons/length/4.png"
                                        alt=""
                                />
                            </template>
                            <template v-else-if="renderDetail.wellTo.depth > 1.5">
                                <img
                                        class="length2"
                                        src="../../../assets/icons/length/3.png"
                                        alt=""
                                />
                            </template>
                            <template v-else-if="renderDetail.wellTo.depth > 1">
                                <img
                                        class="length2"
                                        src="../../../assets/icons/length/2.png"
                                        alt=""
                                />
                            </template>
                            <template v-else-if="renderDetail.wellTo.depth > 0.5">
                                <img
                                        class="length2"
                                        src="../../../assets/icons/length/1.png"
                                        alt=""
                                />
                            </template>
                            <template v-else>
                                <img
                                        class="length2"
                                        src="../../../assets/icons/length/1.png"
                                        alt=""
                                />
                            </template>
                        </template>
                        <template v-else>
                            <img
                                    class="length2"
                                    src="../../../assets/icons/length/1.png"
                                    alt=""
                            />
                        </template>

                        <div class="well-to-depth">
                            井深{{
                            renderDetail.wellTo.depth ? renderDetail.wellTo.depth : "-"
                            }}米
                        </div>
                        <div class="well-to-elevation">
                            地面高程：{{ parseFloat(renderDetail.wellTo.elevation).toFixed(3) }}m
                        </div>
                        <div class="well-to-elevation2">
                            井底高程：{{
                            parseFloat(
                                renderDetail.wellTo.elevation -
                                (renderDetail.wellTo.depth ? renderDetail.wellTo.depth : 0)
                            ).toFixed(3)
                            }}m
                        </div>

                        <div class="well-to-id">窨井编号：{{ renderDetail.wellTo.code }}</div>

                        <template v-if="renderDetail.wellTo.pipeTo">
                            <div class="to-elevation">
                                管底高程：{{ renderDetail.elevationTo }}m
                            </div>

                            <div class="to-elevation2">
                                距离井底：{{
                                parseFloat(
                                    renderDetail.wellTo.depth -
                                    renderDetail.wellTo.pipeTo.buringDepthFrom
                                ).toFixed(3)
                                }}m
                            </div>

                            <div class="to-elevation3">
                                管顶高程：{{
                                parseFloat(
                                    renderDetail.elevationTo +
                                    renderDetail.wellTo.pipeTo.diameter * 0.001
                                ).toFixed(3)
                                }}m
                            </div>
                        </template>
                    </template>

                    <template v-if="renderDetail.drainTo">
                        <div class="well-to-depth">
                            井深{{
                            renderDetail.drainTo.depth ? renderDetail.drainTo.depth : "-"
                            }}米
                        </div>
                        <div class="well-to-elevation">
                            地面高程：{{ parseFloat(renderDetail.drainTo.elevation).toFixed(3) }}m
                        </div>
                        <div class="well-to-elevation2">
                            井底高程：{{
                            parseFloat(
                                renderDetail.drainTo.elevation -
                                (renderDetail.drainTo.depth ? renderDetail.drainTo.depth : 0)
                            ).toFixed(3)
                            }}m
                        </div>

                        <div class="well-to-id">窨井编号：{{ renderDetail.drainTo.code }}</div>

                        <template v-if="renderDetail.drainTo.pipeTo">
                            <div class="to-elevation">
                                管底高程：{{ renderDetail.drainTo.pipeTo.elevationTo }}m
                            </div>

                            <div class="to-elevation2">
                                距离井底：{{
                                parseFloat(
                                    renderDetail.drainTo.depth -
                                    renderDetail.drainTo.pipeTo.buringDepthFrom
                                ).toFixed(3)
                                }}m
                            </div>

                            <div class="to-elevation3">
                                管顶高程：{{
                                parseFloat(
                                    renderDetail.drainTo.pipeTo.elevationTo +
                                    renderDetail.drainTo.pipeTo.diameter * 0.001
                                ).toFixed(3)
                                }}m
                            </div>
                        </template>
                    </template>
                </div>
                <div class="content">
                    <div class="item">
                        <div class="label">编号：</div>
                        <div class="value">{{ renderDetail.code }}</div>
                    </div>

                    <div class="item">
                        <div class="label">所在道路：</div>
                        <div class="value">
                            {{ renderDetail.location ? renderDetail.location : "--" }}
                        </div>
                    </div>

                    <div class="item">
                        <div class="label">材质：</div>
                        <div class="value">{{ renderDetail.material }}</div>
                    </div>
                    <div class="item">
                        <div class="label">管径(mm)：</div>
                        <div class="value">{{ renderDetail.diameter }}</div>
                    </div>

                    <div class="item">
                        <div class="label">埋深-起点(m)：</div>
                        <div class="value">{{ renderDetail.buringDepthFrom }}</div>
                    </div>
                    <div class="item">
                        <div class="label">埋深-终点(m)：</div>
                        <div class="value">{{ renderDetail.buringDepthTo }}</div>
                    </div>

                    <div class="item">
                        <div class="label">高程-起点(m)：</div>
                        <div class="value">{{ renderDetail.elevationFrom }}</div>
                    </div>
                    <div class="item">
                        <div class="label">高程-终点(m)：</div>
                        <div class="value">{{ renderDetail.elevationTo }}</div>
                    </div>
                    <div class="item">
                        <div class="label">管长(m)：</div>
                        <div class="value">{{ renderDetail.length }}</div>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="管段状况" v-if="Object.keys(defectInfoForm).length > 0">
                <div class="tab-content" style="overflow: auto; max-height: 400px;">
                    <div class="tieInWeld">
                        <div>
                            <div class="tieInWeldTitle">结构性缺陷</div>
                            <div style="margin: 0.2rem;">
                                <div style="margin: 0.3rem;color: #fff;">
                                    <div style="color: #adadad;">结构性缺陷</div>
                                    <div>{{ getPipeDefectName(defectInfoForm.structGrade) }}</div>
                                </div>
                                <div style="margin: 0.3rem;color: #fff;">
                                    <div style="color: #adadad;">管段修复</div>
                                    <div>{{ getRepairIndexName(defectInfoForm.structRepair) }}</div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="tieInWeldTitle">功能性缺陷</div>
                            <div style="margin: 0.2rem;">
                                <div style="margin: 0.3rem;color: #fff;">
                                    <div style="color: #adadad;">功能性缺陷</div>
                                    <div>{{ getFunctionDefectName(defectInfoForm.alityGrade) }}</div>
                                </div>
                                <div style="margin: 0.3rem;color: #fff;">
                                    <div style="color: #adadad;">管段修复</div>
                                    <div>{{ getPipeSectionName(defectInfoForm.alityRepair) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="color:#00ffff;">◇ 缺陷管段</div>
                </div>
                <div v-for="(item, index) in defectpipeList" :key="index">
                    <RainPipeDetailInfo :detailInfo="item" />
                </div>
                <div v-if="defectpipeList.length == 0" style="color: #adadad;margin: 1rem;">
                    暂无数据
                </div>
                <video v-if="attachment.length > 0" class="video-player" id="videoPlayer" controls muted style="width: 100%;height: 250px;margin: 0.5rem 0 0 0">
                    <source :src="attachment[0].url" type="video/mp4">
                    浏览器不支持视频播放。
                </video>
            </a-tab-pane>
            <a-tab-pane key="3" tab="历史信息" v-if="projectList.length > 0">
                <Tablelist style="margin-top: 1rem"
                           :showCheckbox="false"
                           :list="projectList"
                           :columns="tableColumns"
                >
                    <template v-slot:actions="{ item }">
                        <a-space>
                            <a v-if="item.attachment" href="#" @click.prevent="download(item)">下载</a>
                            <div v-else>暂无</div>
                        </a-space>
                    </template>
                </Tablelist>
            </a-tab-pane>
        </a-tabs>
      </div>
  </div>
</template>

<script>
import { fetchDetailByCode,fetchDefectPipeList,fetchDetail,fetchDefectTestItemByCode } from "../api/detection";
import { fetchPipeDetail } from "../api/rain";
import RainPipeDetailInfo from "./rain-pipe-detail-info.vue"
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  components:{
      RainPipeDetailInfo
  },
  data() {
    return {
      renderDetail: {},
      activeTab: "1",
      activeTieInTab:"1",
      detailInfoList: [],
      tableColumns:[
          {key: 'projectName',title: '项目',field: 'projectName',infotype: 'text'},
          {key: 'totalQuantity',title: '总数量',field: 'totalQuantity',infotype: 'text'},
          {key: 'totalLength',title: '总长度',field: 'totalLength',infotype: 'text'},
          {key: 'testDate',title: '日期',field: 'testDate',infotype: 'text',},
          {key: 'actions',title: '操作',field: 'actions',infotype: 'template',}
      ],
      defectInfoForm:{},
      defectpipeList:[],
      attachment:[],
      projectList:[],
        pipeDefectList:[
            {name:'Ⅰ等级-无或有轻微缺陷，结构状况基本不受影响，但具有潜在变坏的可能',value:'Ⅰ'},{name:'Ⅱ等级-管段缺陷明显超过一级，具有变坏的趋势',value:'Ⅱ'},
            {name:'Ⅲ等级-管段缺陷严重，结构状况受到影响',value:'Ⅲ'},{name:'Ⅳ等级-管段存在重大缺陷，损坏严重或即将导致破坏',value:'Ⅳ'},
        ],
        repairIndexList:[
            {name:'Ⅰ等级-结构条件基本完好，不修复',value:'Ⅰ'},{name:'Ⅱ等级-结构在短期内不会发生破坏现象，但应做修复计划',value:'Ⅱ'},
            {name:'Ⅲ等级-结构在短期内可能会发生破坏，应尽快修复',value:'Ⅲ'},{name:'Ⅳ等级-结构已经发生或即将发生破坏，应立即修复',value:'Ⅳ'},
        ],
        functionDefectList:[
            {name:'Ⅰ等级-无或有轻微影响，管道运行基本不受影响',value:'Ⅰ'},{name:'Ⅱ等级-管道过流有一定的受阻，运行受影响不大',value:'Ⅱ'},
            {name:'Ⅲ等级-管道过流受阻比较严重，运行受到明显影响',value:'Ⅲ'}, {name:'Ⅳ等级-管道过流受阻很严重，即将或已经导致运行瘫痪',value:'Ⅳ'},
        ],
        pipeSectionList:[
            {name:'Ⅰ等级-没有明显需要处理的缺陷',value:'Ⅰ'},{name:'Ⅱ等级-没有立即进行处理的必要，但宜安排处理计划',value:'Ⅱ'},
            {name:'Ⅲ等级-根据基础数据进行全面的考虑，应尽快处理',value:'Ⅲ'},{name:'Ⅳ等级-输水功能受到严重影响，应立即进行处理',value:'Ⅳ'},
        ],
    };
  },
  watch: {
    detail() {
      this.getDetail();
    },
  },
  mounted() {
    this.getDetail();
  },
  methods: {
      getPipeDefectName(value) {
          const item = this.pipeDefectList.find(item => item.value === value);
          return item ? item.name : '';
      },
      getRepairIndexName(value) {
          const item = this.repairIndexList.find(item => item.value === value);
          return item ? item.name : '';
      },
      getFunctionDefectName(value) {
          const item = this.functionDefectList.find(item => item.value === value);
          return item ? item.name : '';
      },
      getPipeSectionName(value) {
          const item = this.pipeSectionList.find(item => item.value === value);
          return item ? item.name : '';
      },
    download(item) {
      if (item.attachment) {
          const attachments = item.attachment.split(';').map((url) => url.trim());
          attachments.forEach((url) => {
              if (url) {
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = url.substring(url.lastIndexOf('/') + 1);
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
              }
          });
      }
    },
    fetchDefectTestItemByCode(){
        this.projectList = []
        console.log("this.renderDetail.code::",this.renderDetail.code)
        fetchDefectTestItemByCode({
            code:this.renderDetail.code
        }).then((res) => {
            this.projectList = res.list.map(item => ({
                ...item,
                testDate: this.formatDate(item.testDate)
            }));
            console.log("fetchDefectTestItemByCode = res:::",res.list)
        })
    },
    formatDate(dateString){
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
   },
    parseAttachment(attachment) {
          if (!attachment) {
              return [];
          }

          const urls = attachment.split(";");
          return urls.map((url) => ({ url: url.trim() }));
      },
    getDefectInfoDetail() {
        this.defectInfoForm = {}
        this.attachment = []
        fetchDetailByCode({
            code:this.renderDetail.code,
            type:'defect_info'
        }).then((res) => {
            console.log("getDefectInfoDetail = res:::",res)
            this.defectInfoForm = res;
            this.attachment = this.parseAttachment(res.videoUrl)
            this.getDefectPipeDetail(res);
            // this.getDefectTestItemDetail(res.defectId);
        })
    },
    getDefectTestItemDetail(defectId){
        fetchDetail({
            id: defectId,
            type:'defect_test_item'
        }).then((res) => {
            // this.attachment = this.parseAttachment(res.attachment)
            console.log("this.attachment:::::",res)
        })
    },
    getDefectPipeDetail(res) {
        fetchDefectPipeList({
              code:res.code,
              defectInfoId:res.id
          }).then((res) => {
              console.log("getDefectPipeDetail = res:::",res)
              this.defectpipeList = res.list;
          })
    },
    getDetail() {
      fetchPipeDetail({
        ids: [this.detail.id],
        type: "rain",
      }).then((res) => {
        if (Array.isArray(res) && res.length > 0) {
          const item = res[0];
          this.renderDetail = {
            ...item,
            pipeFrom:
              item.pipesFrom && item.pipesFrom[0] ? item.pipesFrom[0] : null,
            pipeTo: item.pipesTo && item.pipesTo[0] ? item.pipesTo[0] : null,
          };

            this.getDefectInfoDetail();
            this.fetchDefectTestItemByCode();
        }
      });
    },
  },
};
</script>


<style lang="less" scoped>
.detail {
  position: fixed;
  top: 11vh;
  right: calc(1vw + 140px);
  bottom: 2vh;
  z-index: 99;
  background-color: var(--detail-bgcolor);
  width: 30vw;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border: 1px solid #0b4948;
  & > .header {
    background-color: var(--default-bgcolor);
    color: #fff;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1vw;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    .extra {
      cursor: pointer;
    }
  }

  .content {
    margin-top: 4vh;
    padding: 2vh 1vw;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 0.5vh;
    color: #fff;
    .item {
      display: flex;
      align-items: center;

      .label {
        width: 8em;
      }

      .value {
        color: var(--theme-color);
      }
    }
  }

  .tieInWeld{
      display: flex;
      justify-content: space-between;
  }
  .tieInWeld > div{
        width: 48%;
  }
  .tieInWeldTitle{
      color: #00ffff;
      font-size: 0.9rem;
      font-weight: bold;
  }

  .tieInInfo{
      display: flex;
      justify-content: start;
      color: #adadad;
      margin: 0.5rem 0;
  }
    .tieInVal{
        color:var(--theme-color);
    }

  .tieInTitle{
      width: 50%;
  }

}

.pipe {
  position: relative;
  padding: 4vh 0;
  font-size: 1.2vh;
  color: #9e9e9e;
  .bg {
    height: 30vh;
    width: 22vw;
    display: block;
    margin: 0 auto;
  }

  .length1 {
    width: 3.25vw;
    position: absolute;
    bottom: 8.9vh;
    left: 6.6vw;
  }
  .length2 {
    width: 3.25vw;
    position: absolute;
    bottom: 8.9vh;
    right: 6.6vw;
  }

  .well-from-depth {
    border-top: 2px solid #999;
    border-bottom: 2px solid #999;
    position: absolute;
    top: 6vh;
    bottom: 4vh;
    left: 1vw;
    writing-mode: vertical-lr;
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      content: "";
      position: absolute;
      left: 49%;
      top: 0;
      height: 40%;
      width: 1px;
      background-color: #999;
    }
    &::after {
      content: "";
      position: absolute;
      left: 49%;
      bottom: 0;
      height: 40%;
      width: 1px;
      background-color: #999;
    }
  }

  .well-from-elevation {
    position: absolute;
    top: 1vh;
    left: 20%;
  }
  .well-from-elevation2 {
    position: absolute;
    bottom: -2vh;
    left: 20%;
  }

  .well-from-id {
    position: absolute;
    bottom: 0;
    left: 20%;
  }

  .well-to-depth {
    border-top: 2px solid #999;
    border-bottom: 2px solid #999;
    position: absolute;
    top: 6vh;
    bottom: 4vh;
    right: calc(1vw + 140px);
    writing-mode: vertical-lr;
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      content: "";
      position: absolute;
      left: 49%;
      top: 0;
      height: 40%;
      width: 1px;
      background-color: #999;
    }
    &::after {
      content: "";
      position: absolute;
      left: 49%;
      bottom: 0;
      height: 40%;
      width: 1px;
      background-color: #999;
    }
  }

  .well-to-elevation {
    position: absolute;
    top: 1vh;
    right: 20%;
  }
  .well-to-elevation2 {
    position: absolute;
    bottom: -2vh;
    right: 20%;
  }
  .well-to-id {
    position: absolute;
    bottom: 0;
    right: 20%;
  }

  .from-elevation {
    display: flex;
    align-items: center;
    position: absolute;
    left: 8%;
    bottom: 2vh;
  }
  .from-elevation2 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 8%;
    bottom: 4vh;
  }
  .from-elevation3 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 8%;
    bottom: 12vh;
  }

  .to-elevation {
    display: flex;
    align-items: center;
    position: absolute;
    right: 8%;
    bottom: 2vh;
  }
  .to-elevation2 {
    display: flex;
    align-items: center;
    position: absolute;
    right: 8%;
    bottom: 4vh;
  }
  .to-elevation3 {
    display: flex;
    align-items: center;
    position: absolute;
    right: 8%;
    bottom: 12vh;
  }
}

::v-deep .ant-tabs-nav .ant-tabs-tab-active{
  color: #00fd95;
  text-shadow: 0 0 0.25px #00fd95;
}
::v-deep .ant-tabs-ink-bar{
    background: #00ff96;
}
::v-deep .ant-tabs-tab{
  color:#fff;
}

.tabsTieIn ::v-deep .ant-tabs-nav .ant-tabs-tab-active{
    color: #00e0e2;
    text-shadow: 0 0 0.25px #00e0e2;
}
.tabsTieIn  ::v-deep .ant-tabs-ink-bar{
    background: #00e0e2;
}
</style>